KROWN.themeName = 'Split';
KROWN.themeVersion = '4.2.1';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-newsletter') ) {
    const newsletterPopup = document.getElementById('modal-newsletter');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

  // Override app-embed-container-72984 styling
  const stylePopup = new CSSStyleSheet;
  stylePopup.replaceSync(`
    input[type],
    textarea[name] {
      border-radius: 0;
      height: var(--button-size);
      padding: 0 20px;
    }
    textarea[name] {
      padding-top: 21px !important;
    }
    input[type] + label {
      --input-label-transform: translate(0, -50%);
      --input-label-top: 50%;
      opacity: 1;
      transform: translate(0, -50%);
    }
    textarea[name] + label {
      --input-label-transform: none;
      --input-label-top: 21px;
      opacity: 1;
      transform: none;
    }
    input[type]:focus + label,
    input[type] + label[class*="inputFilled"],
    textarea[name]:focus + label,
    textarea[name] + label[class*="inputFilled"]{
      opacity: 0;
    }
    button[type="submit"] {
      border-radius: 0;
      clip-path: polygon(100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 0);
      font-weight: 600;
      text-transform: uppercase;
    }
    p a[href^="tel:"],
    p a[href^="mailto:"] {
      display: block;
      font-size: 16px;
      margin-top: 1em;
      text-align: left;
      text-decoration: none;
    }
    p a[href^="tel:"]::before,
    p a[href^="mailto:"]::before {
      background-position: center;
      background-size: contain;
      content: '';
      display: inline-block;
      margin-right: 1em;
      width: 25px;
      height: 25px;
      vertical-align: middle;
    }
    p a[href^="mailto:"]::before {
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 25 25'%3E%3Cpath fill='%23000' stroke='%23000' stroke-width='.5' d='M2.4 4.53h20.2a1.85 1.85 0 0 1 1.85 1.86V18.6a1.85 1.85 0 0 1-1.86 1.86H2.4A1.85 1.85 0 0 1 .55 18.6V6.4A1.85 1.85 0 0 1 2.4 4.53Zm10.1 10.76 10.92-9.11a.86.86 0 0 0-.83-.65H2.4a.85.85 0 0 0-.83.65l10.93 9.11Zm-3.97-2.01-6.95 5.55a.86.86 0 0 0 .82.64h20.2a.86.86 0 0 0 .82-.64l-6.95-5.55-3.65 3.04a.5.5 0 0 1-.64 0l-3.65-3.04Zm-6.98 4.3 6.2-4.95-6.2-5.18v10.13Zm15.7-4.95 6.2 4.95V7.45l-6.2 5.18Z'/%3E%3C/svg%3E");
    }
    p a[href^="tel:"]::before {
      background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 25 25'%3E%3Cg clip-path='url(%23a)'%3E%3Cpath stroke='%23000' stroke-width='2' d='m23.5 17.77-7.41-1.7a4.47 4.47 0 0 0-1.25 2.42 13.5 13.5 0 0 1-8.27-8.33c.94-.15 1.79-.6 2.44-1.25L7.34 1.5a4.19 4.19 0 0 0-1.5-.27 4.49 4.49 0 0 0-4.5 4.45v.09c0 9.89 8 17.91 17.87 17.96h.07a4.49 4.49 0 0 0 4.22-5.97Z'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23000' d='M0 0h25v25H0z'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
    }
  `);

  const ivlPopupStyles = setInterval(() => {
    // Poll for the existence of the popup form
    const elPopupForm = document.getElementById('app-embed-container-72984');
    if (elPopupForm) {
      elPopupForm.shadowRoot.adoptedStyleSheets.push(stylePopup)
      clearInterval(ivlPopupStyles);
    }
  }, 500);

  // Override app-embed-container-72984 styling
  const styleBechmarkForm = new CSSStyleSheet;
  styleBechmarkForm.replaceSync(`
    button {
      background-color: #000000 !important;
      background-position: 0 0, 0 0, right bottom, right bottom, right bottom !important;
      background-repeat: repeat-x, repeat-y, repeat-x, repeat-y, no-repeat !important;
      background-size: auto, auto, auto, auto, 10px !important;
      border-radius: 0 !important;
      border-width: 0 !important;
      clip-path: polygon(100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 0) !important;
      color: #fff !important;
      position: relative !important;
      transition: background-color 0.4s, color 0.4s !important;
    }
    button:hover {
      background-color: #fff !important;
      color: #000 !important;
      filter: none !important;
    }
    button::before {
      background-color: #fff;
      clip-path: polygon(0% 0%, 0% 100%, 1px 100%, 1px 1px, calc(100% - 1px) 1px, calc(100% - 1px) calc(100% - 10px), calc(100% - 10px) calc(100% - 1px), 1px calc(100% - 1px), 1px 100%, calc(100% - 10px) 100%, 100% calc(100% - 10px), 100% 0%);
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      transition: all .15s;
    }
    button::after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid' style='width:21px; height: 10px;' viewBox='0 0 21 10'%3e%3cpath d='M21.000,5.000 L15.000,10.000 L15.000,6.000 L-0.000,6.000 L-0.000,4.000 L15.000,4.000 L15.000,0.000 L21.000,5.000 Z'%3e%3c/path%3e%3c/svg%3e");
      background-position: right center;
      background-repeat: no-repeat;
      background-size: 21px 10px;
      content: '';
      opacity: 0;
      width: 0;
      transition: width 0.4s, opacity 0.4s;
    }
    button:hover::after {
      opacity: 1;
      width: 26px;
    }
  `);

  const ivlBechmarkForm = setInterval(() => {
    // Poll for the existence of the benchmark form
    const elBenchmarkForm = document.querySelector('[data-forms-id="forms-root-430059"] form-embed');
    if (elBenchmarkForm) {
      elBenchmarkForm.shadowRoot.adoptedStyleSheets.push(styleBechmarkForm)
      clearInterval(ivlBechmarkForm);
    }
  }, 500);

  // Change buy it now button text
  if (document.body.classList.contains('template-product-subscription-product')) {
    const ivlSetButton = setInterval(() => {
      const elBuyButton = document.querySelector('.product--add-to-cart-form .shopify-payment-button__button:not(.shopify-payment-button__button--hidden)');
  
      if (elBuyButton) {
        const elText = elBuyButton.querySelector('[aria-hidden]');
        const elSvg = elBuyButton.querySelector('svg use');

        console.log(`elSvg`, elSvg);
        // elBuyButton.textContent = `Subscribe`;
        // elBuyButton.classList.add(`--visible`);

        const styleSvg = new CSSStyleSheet;
        styleSvg.replaceSync(`
          path {
            fill: black !important;
          }
        `);
        // elSvg.shadowRoot.adoptedStyleSheets.push(styleSvg);

        elText.textContent = `Subscribe with `;
        
        clearInterval(ivlSetButton);
      } 
    }, 100);
  }
}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

}